import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import "./Notification.css"
import PushNotification from './PushNotification';
import EmailNotification from './EmailNotification';

const NotificationList = () => {
  const selectedUser = useSelector(({ user: { userbyid } }) => userbyid);

  const [activeTab, setActiveTab] = useState('editUser'); 


  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className='col-md-12'>
      <div className="tabs-container px-0">
        <button
          onClick={() => handleTabClick('editUser')}
          className={`tab-button ${activeTab === 'editUser' ? 'active' : ''}`}
        >
          Push Notification
        </button>
        <button
          onClick={() => handleTabClick('report')}
          className={`tab-button ${activeTab === 'report' ? 'active' : ''}`}
        >
          Email Notification
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'editUser' && <div><PushNotification></PushNotification></div>}
        {activeTab === 'report' && <div><EmailNotification></EmailNotification></div> }
      </div>
    </div>
  );
};



export default NotificationList;
